import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TestimonialeHero() {
  return <section className="relative pt-32 pb-20 lg:pt-44 lg:pb-24 overflow-hidden bg-brand-cream" data-id="element-1913">
      {/* Decorative blobs */}
      <div className="absolute top-1/4 -right-32 w-[420px] h-[420px] bg-brand-gold/15 rounded-full blur-3xl pointer-events-none" data-id="element-1914" />
      <div className="absolute -bottom-24 -left-32 w-[360px] h-[360px] bg-brand-purple/15 rounded-full blur-3xl pointer-events-none" data-id="element-1915" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-1916">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-1917">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-purple/10 text-brand-purple text-xs font-heading font-bold uppercase tracking-[0.15em] mb-6" data-id="element-1918">
            <Quote className="w-3.5 h-3.5" data-id="element-1919" />
            Mărturii reale, transformări reale
          </div>

          <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-brand-text mb-6 leading-[1.1]" data-id="element-1920">
            Ce spun oamenii care au lucrat cu mine
          </h1>

          <div className="h-[2px] w-16 bg-brand-gold mx-auto rounded-full mb-6" data-id="element-1921" />

          <p className="font-subtitle text-lg md:text-xl text-brand-textSec leading-relaxed" data-id="element-1922">
            De peste 25 de ani lucrez cu oameni care vor mai mult de la viața
            lor. Mai jos găsești o parte din poveștile celor care au făcut pasul
            și au schimbat ceva esențial în interiorul lor.
          </p>
        </motion.div>
      </div>
    </section>;
}